<template>
    <BasePanel
        headline="lang_LABEL_RELEASES_PANEL_CAPTION_PROFIT_AND_LOSS"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-row >
                <v-card elevation="0">
                    <v-card-text>
                        <v-row>
                            <v-col cols="4"
                                class="pt-9 pl-2"
                                :alvqa="alvqa + '-result'"
                            >
                                {{ $t('lang_LABEL_STATEMENTS_CAPTION_RESULT') }}:
                                {{ $n(getProfitAndLossResult, 'number') }} {{ $store.getters.getSelectedCurrency }}
                            </v-col>
                            <v-col>
                                <BaseEditPageDatePicker 
                                    :context="context+'Filter'"
                                    field="FromMonth"
                                    :label="$t('lang_GENERIC_CAPTION_PERIOD_FROM')"
                                    :withMargin="false"
                                    :alvqa="alvqa + '-datepicker-from-month'"
                                    type="month"
                                    :clearable="false"
                                />
                            </v-col>
                            <v-col >
                                <BaseEditPageDatePicker 
                                    :context="context+'Filter'"
                                    field="ToMonth"
                                    :label="$t('lang_GENERIC_CAPTION_PERIOD_TO')"
                                    :withMargin="false"
                                    :alvqa="alvqa + '-datepicker-to-month'"
                                    type="month"
                                    :clearable="false"
                                />
                            </v-col>
                            <span class="pt-6">
                                <BaseIcon 
                                    :alvqa="alvqa + '-icon-search'"
                                    @click="filter" 
                                    icon="fa-search" 
                                    tooltipText="lang_GENERAL_CAPTION_START_SEARCH" 
                                />
                            </span>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-spacer></v-spacer>
                <v-col
                    cols="2"
                    align-self="center"
                    class="pt-1"
                >
                    <BaseButton 
                        label="lang_GENERIC_CAPTION_EXPORT"
                        block
                        @click="exportData()"
                        icon="library_books"
                        :alvqa="alvqa + '-button-export'"
                    />
                </v-col>
            </v-row>
            <ProfitAndLossCostsDataTableReadOnly :releaseAlvId="releaseAlvId" />
            <ProfitAndLossIncomeDataTableReadOnly :releaseAlvId="releaseAlvId" class="pt-3" />
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'
import BaseIcon from '@/components/_buttons/BaseIcon'
import ProfitAndLossCostsDataTableReadOnly from './ProfitAndLossCostsDataTableReadOnly'
import ProfitAndLossIncomeDataTableReadOnly from './ProfitAndLossIncomeDataTableReadOnly'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "ReleasesProfitAndLossReadOnlyPanel",
    components: {
        BasePanel,
        BaseEditPageDatePicker,
        BaseIcon,
        ProfitAndLossCostsDataTableReadOnly,
        ProfitAndLossIncomeDataTableReadOnly,
        BaseButton
    },
    props: {
        releaseAlvId: {
            type: String
        }
    },
    data() {
        return {
            context: "ProfitAndLoss",
            alvqa: 'label-releases-list-row-' + this.releaseAlvId + '-read-only-panel-profit-and-loss',
        }
    },
    computed: {
        getProfitAndLossResult() { return this.$store.getters.getReleasesProfitAndLossResult }
    },
    methods: {
        filter() {
            this.$store.commit('setSelectedProfitAndLossFilterCostGroup', null)
            this.$store.commit('setSelectedProfitAndLossFilterIncomeGroup', null)

            this.$store.dispatch('fetchReleaseProfitAndLoss')
        },
        exportData(){
            this.$store.dispatch('exportProfitAndLossData')
        }
    },
    created() {
        // set "to month" datepicker filter for panel
        let tempToMonth = new Date()
       
        this.$store.commit('setProfitAndLossFilterDetailsToMonth',this.$alvPlugin.dateToISOFormat(tempToMonth)) 

        // set "from month" datepicker filter for panel, depending on physical/digital date (earliest if both filled in)
        let physicalDate = this.$store.getters.getLabelReleasesDetailsDatePhysical
        let digitalDate = this.$store.getters.getLabelReleasesDetailsDateDigital
        let fromMonth

        // if(physicalDate !== null && digitalDate !== null) {
        //     if(physicalDate >= digitalDate) fromMonth = digitalDate
        //     else fromMonth = physicalDate
        // } else {
        //     if(physicalDate === null && digitalDate === null) {
        //         let tempDate = new Date("2008", 0)
        //         fromMonth = this.$alvPlugin.dateToISOFormat(tempDate)
        //     }
        //     else { 
        //         if (physicalDate === null) fromMonth = digitalDate
        //         if (digitalDate === null) fromMonth = physicalDate
        //     }
        // }

        // default to earliest date possible, as costs of Release are incurred well before release date
        let tempDate = new Date("2008", 0)
        fromMonth = this.$alvPlugin.dateToISOFormat(tempDate)

        this.$store.commit('setProfitAndLossFilterDetailsFromMonth', fromMonth)

        // get start result (without month filter) from DB
        this.$store.dispatch('fetchReleaseProfitAndLoss')
    }
}
</script>